import { Component, AfterViewInit, ViewChild, ElementRef, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ItemService } from '../../../service/item/item.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { DataSource } from '../../../classes/dataSource/dataSource';

@Component({
  selector: 'wa0010',
  templateUrl: 'wa0010.component.html',
  styleUrls: ['wa0010.component.scss']
})

export class Wa0010Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA0010:商品選択';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private dataSource: DataSource;

  public ownerId: number;
  public ownerResult: any;

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isEnableClearFilter = false;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Input() isOwnerId = '0';
  private isDelayHide = true;

  private errorInfo = '';

  constructor(
    private router: Router,
    private itemService: ItemService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    const querystrings = (this.ownerId) ? { 'ownerId': this.ownerId } : '';
    this.dataSource = new DataSource({
      parent: this,
      service: this.itemService,
      resultKey: 'items',
      querystrings: querystrings,
      beforeRequest: this.handleBeforeRequest.bind(this),
      successCallback: this.handleRequestSucc.bind(this)
    });

    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      rowModelType: 'infinite',
      cacheBlockSize: Number(this.rowsPerPage),
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa0010_${column.getColId()}_idx`);
          if (idx !== null) {
            if (idx !== null) {
              columns.push({ idx: parseInt(idx, 10), column: column });
            }
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        // this.gridHelper.onGridFilterChanged();
        this.gridHelper.renderGridCheckboxImage();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        // if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        // else this.gridHelper.isShowGridNoDataOverlay = true;
        this.gridHelper.renderGridCheckboxImage();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 240),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'], pinned: 'left'
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        sort: 'asc',
        width: this.getColumnWidth('itemCd', 150),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass'], pinned: 'left'
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 520),
        unSortIcon: true,
        suppressMenu: true, cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa0010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa0010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa0010_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin
  }

  onSubmit() {
    let parameter;

    this.working = true;

    // 呼び出し元で ownerId を指定すると、検索結果を絞り込みます。
    let ownerResult = sessionStorage.getItem('ownerResult');

    let ownerId = '';
    if (ownerResult !== null) {
      const selectedOwner = JSON.parse(ownerResult);
      ownerId = selectedOwner.ownerId;
    } else if (this.isOwnerId !== '0') {
      ownerId = this.isOwnerId;
    }

    let querystrings = undefined;
    if (ownerId !== '') {
      querystrings = { 'ownerId': ownerId };
    } 

    this.gridOptions.api.setDatasource(
      new DataSource({
        parent: this,
        service: this.itemService,
        resultKey: 'items',
        querystrings: querystrings,
        beforeRequest: this.handleBeforeRequest.bind(this),
        successCallback: this.handleRequestSucc.bind(this)
      })
    );

  }

  onSelect() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }

    let selectedData = this.gridOptions.api.getSelectedNodes()[0]['data'];
    this.closeButtonClick.emit(selectedData);
  }

  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }
  
  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  cancel() {
    this.closeButtonClick.emit(null);
  }

  initDatas() {
    this.gridOptions.api.deselectAll();
    this.gridOptions.api.setFilterModel(null);
    this.onSubmit();
    setTimeout(() => {
      this.gridHelper.insertLoadingOverlay()
    })
  }

  resetData () {
    this.rowData = []
  }

  private handleBeforeRequest () {
    this.gridOptions.api.showLoadingOverlay()
  }

  private handleRequestSucc () {
    this.gridOptions.api.hideOverlay()
  }
  
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0010/wa0010.component.ts